import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
  console.error('Global error handler:', event.error);
  console.error('Error details:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  console.error('Rejection details:', event.reason);
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);

try {
  if (import.meta.env.DEV) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    root.render(<App />);
  }
} catch (error) {
  console.error("Error rendering app:", error);
  root.render(
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h1>Error loading application</h1>
      <p>{String(error)}</p>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}
